export default __webpack_public_path__ + "static/banner_home_1-0e8b116a3ce37e2ca83cdaf6caaa4df2.jpg";